<template>
    <div>
        <div>

            <van-sticky>
                <div style="padding: 10px 0px 0px 0px">
                    <van-icon name="arrow-left" size="20px" @click="onback"/>
                </div>
            </van-sticky>
            <div class="content">
                <Card style="width:100%">
                    <cell size="small" style="padding: 0px;">
                        <label>订单号：
                            <label style="color: #0077aa;">{{maintainOrdersDetail.orderNum}}</label>
                        </label><br/>
                    </cell>

                    <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo==null?'':maintainOrdersDetail.vehicleInfo.registrationNum}}</label>
                                </span>
                        <span class="distance fr">|</span>
                        <span class="time fr">车架号:
                                                                <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo==null?'':maintainOrdersDetail.vehicleInfo.vin}}</label>
                                                            </span>
                    </div>
                    <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo==null?'':maintainOrdersDetail.vehicleInfo.engineNum}}</label>
                                </span>
                    </div>
                    <div class="mid">
                    <span class="time fr">问题描述:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.question==null?'':maintainOrdersDetail.question}}</label>
                                </span>
                    </div>
<!--                    <div class="mid">-->
<!--                                <span class="count fl">预约维修时间:-->
<!--                                    <label style="color: #0077aa;">{{maintainOrdersDetail.bookingDatetime==null?'':new Date(maintainOrdersDetail.bookingDatetime).Format('yyyy年MM月dd日')}}</label>-->
<!--                                </span>-->
<!--                    </div>-->
                    <div class="mid" v-if="maintainOrdersDetail.bookingDatetime || maintainOrdersDetail.actualDatetime">
                                <span class="count fl" v-if="!maintainOrdersDetail.actualDatetime">
                                    预约时间:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.bookingDatetime == null?'无':new Date(maintainOrdersDetail.bookingDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}
                                    </label>
                                </span>
                        <span v-else>
                                    重新预约时间:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.actualDatetime == null?'无':new Date(maintainOrdersDetail.actualDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}
                                    </label>
                                </span>
                    </div>
                    <div class="mid" v-if="maintainOrdersDetail.bookingPlace || maintainOrdersDetail.actualPlace">
                                <span class="count fl" v-if="!maintainOrdersDetail.actualDatetime">
                                    预约地点:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.bookingPlace == null?'无':maintainOrdersDetail.bookingPlace}}
                                    </label>
                                </span>
                        <span v-else>
                                    重新预约地点:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.actualPlace == null?'无':maintainOrdersDetail.actualPlace}}
                                    </label>
                                </span>
                    </div>
<!--                    <div class="mid">-->
<!--                                <span class="count fl">客户姓名:-->
<!--                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo.clientInfo==null?'':maintainOrdersDetail.vehicleInfo.clientInfo.name}}</label>-->
<!--                                    &lt;!&ndash;                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>&ndash;&gt;-->
<!--                                </span>-->
<!--                        <span class="distance fr">|</span>-->
<!--                        <span class="time fr">客户电话:-->
<!--                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo.clientInfo==null?'':maintainOrdersDetail.vehicleInfo.clientInfo.phoneNum}}</label>-->
<!--                                </span>-->
<!--                    </div>-->
<!--                    <div class="mid">-->
<!--                                <span class="count fl">客户地址:-->
<!--                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo.clientInfo==null?'':maintainOrdersDetail.vehicleInfo.clientInfo.address}}</label>-->
<!--                                    &lt;!&ndash;                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>&ndash;&gt;-->
<!--                                </span>-->
<!--                    </div>-->
                    <div class="mid">
                                                            <span class="count fl">客户姓名:
                                                                <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo!=null?maintainOrdersDetail.vehicleInfo.clientInfo!=null?maintainOrdersDetail.vehicleInfo.clientInfo.name:maintainOrdersDetail.clientInfo!=null?maintainOrdersDetail.clientInfo.name:'无':'无'}}</label>
                                                                <!--                                    <label style="color: #0077aa;">{{maintainOrdersDetail.tempVehicleInfo.registrationNum}}</label>-->
                                                            </span>
                        <span class="distance fr">|</span>
                        <span class="time fr">客户电话:
                                                                <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo!=null?maintainOrdersDetail.vehicleInfo.clientInfo!=null?maintainOrdersDetail.vehicleInfo.clientInfo.phoneNum:maintainOrdersDetail.clientInfo!=null?maintainOrdersDetail.clientInfo.phoneNum:'无':'无'}}</label>
                                                            </span>
                    </div>
                    <div class="mid">
                                                            <span class="count fl">客户地址:
                                                                <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo!=null?maintainOrdersDetail.vehicleInfo.clientInfo!=null?maintainOrdersDetail.vehicleInfo.clientInfo.address:maintainOrdersDetail.clientInfo!=null?maintainOrdersDetail.clientInfo.address:'无':'无'}}</label>
                                                                <!--                                    <label style="color: #0077aa;">{{maintainOrdersDetail.tempVehicleInfo.registrationNum}}</label>-->
                                                            </span>
                    </div>


                    <div class="mid">
                                <span class="count fl">备注:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.remark==null?'':maintainOrdersDetail.remark}}</label>
                                </span><br>
                        <van-button size="small" type="info"
                                    :disabled="disabled1" @click="addremark(maintainOrdersDetail)">追加备注
                        </van-button>&nbsp;
                    </div>
                    <div class="mid">
                                <span class="count fl">公司联系人:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.createUser==null?'':maintainOrdersDetail.createUser.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                        <span class="distance fr">|</span>
                        <span class="time fr">公司联系人电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.createUser==null?'':maintainOrdersDetail.createUser.mobilePhoneNum}}</label>
                                </span>
                    </div>
                    <div class="mid">
                                <span class="count fl">订单业务员:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.businessUser==null?'':maintainOrdersDetail.businessUser.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                        <span class="distance fr">|</span>
                        <span class="time fr">订单业务员电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.businessUser==null?'':maintainOrdersDetail.businessUser.mobilePhoneNum}}</label>
                                </span>
                    </div>
                    <div class="mid">
                                <span class="count fl">订单维修员:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.maintainer==null?'':maintainOrdersDetail.maintainer.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                        <span class="distance fr">|</span>
                        <span class="time fr">订单维修员电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.maintainer==null?'':maintainOrdersDetail.maintainer.mobilePhoneNum}}</label>
                                </span>
                    </div>
                    <div class="mid">
                                <span class="count fl">维修记录:
                                    <div v-for="maintainDeviceRecorditem in maintainOrdersDetail.maintainDeviceRecords">
                                    <label style="color: #0077aa;">{{maintainDeviceRecorditem.terminalNum==null?'':maintainDeviceRecorditem.terminalNum+'(' + maintainDeviceRecorditem.positioningDeviceInfo.positioningDeviceModel.name + ')'}}</label>
                                        <span class="distance fr">|</span>
                                        <label style="color: #0077aa;">{{maintainDeviceRecorditem.result==null?'未维修':maintainDeviceRecorditem.result}}</label>
                                    </div>
                                </span>
                    </div>
                    <div class="mid">
                                <span class="count fl">订单状态:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.state==0?'作废':maintainOrdersDetail.state==1?'待指派':maintainOrdersDetail.state==2?'待维修':'维修完成'}}</label>
                                </span>
                        <span class="distance fr">|</span>
                        <span class="time fr">维修结果:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.result==null?'':maintainOrdersDetail.result}}</label>
                                </span>
                    </div>

                    <div class="mid">
                                <span class="count fl">维修完成时间:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.maintainDatetime == 0?'无':new Date(maintainOrdersDetail.maintainDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                                </span>
                    </div>

                    <div class="mid">
                                <span class="count fl">历史记录:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.history}}</label>
                                </span>
                    </div>

                    <div>
                        <div style="position: relative;left: 25%;margin-bottom: 5px;">
                            <van-button size="small" type="info"style="margin-right: 5px;"
                                        :disabled="disabled" @click="onMaintainOrderChangeMaintainerModal(maintainOrdersDetail)">指派维修员
                            </van-button>
                            <van-button size="small" type="info"
                                        :disabled="disabled" @click="onReschedule(maintainOrdersDetail)">重新预约
                            </van-button>
                        </div>
                        <div style="position: relative;left: 25%;">
                        <a :href="'../installermaintainorderconfirm?maintainOrdersDetailid='+maintainOrdersDetail.id" style="padding-right: 5px;">
                            <van-button v-if="maintainOrdersDetail.installed===true?false:true" size="small" type="info"
                                        :disabled="disabled">确认维修
                            </van-button>
                        </a>
                        </div>
                    </div>

                </Card>
                <div style="height: 3px"></div>
                <!--                        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
                <!--                        </van-divider>-->
            </div>
        </div>
        <div>
            <Modal
                    v-model="remarkmodal"
                    title="添加备注"
                    @on-ok="ok1"
                    @on-cancel="cancel1">
                <van-cell-group>
                    <van-field
                            v-model="remarkvalue"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入追加备注"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
        </div>
        <!--    指派维修员    -->
        <maintain-order-change-maintainer-modal v-model="maintainOrderChangeMaintainerModal"
                                                :initValue="maintainOrderChangeMaintainerId"
                                                @on-success="onback"></maintain-order-change-maintainer-modal>
        <reschedule-maintainer-modal v-model="rescheduleMaintainerModal" :initValue="rescheduleMaintainerId"
                                     @on-success="refresh"></reschedule-maintainer-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

    import MaintainOrderChangeMaintainerModal from '@/views/om/maintain-order/components/maintain-order-change-maintainer-modal'
    import RescheduleMaintainerModal from '@/views/om/installer-maintain-order/components/reschedule-maintainer-modal'

    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NumberKeyboard,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(NumberKeyboard)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "installer-maintain-order-details",
        components: {
            MaintainOrderChangeMaintainerModal,
            RescheduleMaintainerModal,
        },
        data() {
            return {
                // 增加设备维修记录
                maintainOrderAddMaintainDeviceRecordModal:false,
                maintainOrderAddMaintainDeviceRecordId:null,

                // 删除设备维修记录
                maintainOrderDeleteMaintainDeviceRecordModal: false,
                maintainOrderDeleteMaintainDeviceRecordId: null,

                // 修改设备维修记录
                maintainOrderModifyMaintainDeviceRecordModal: false,
                maintainOrderModifyMaintainDeviceRecordId: null,

                // 指定业务跟进
                changeBusinessUserModal: false,
                changeBusinessUserId: null,

                // 指派维修员
                maintainOrderChangeMaintainerModal: false,
                maintainOrderChangeMaintainerId: null,

                //重新预约安装订单
                rescheduleMaintainerModal: false,
                rescheduleMaintainerId: null,

                maintainOrdersDetail:[123,321],

                //修改表单
                maintainDeviceRecord: {
                    terminalNum: null,
                    newTerminalNum: null,
                    newFactoryTerminalNum: null,
                    newPositioningDeviceModel: null,
                    newPositioningDeviceModelId: null,
                    changeDevice: false,
                    changeSim: false,
                    removeDevice: false,
                    positioningDeviceInfoId: null,
                    positioningDeviceInfo: null,
                    result: null,
                    maintainOrderId: null,
                },

                remarkid:null,
                modal1:false,
                disabled: false,
                disabled1:false,
                remarkmodal:false,
                remarkvalue:'',
            }
        },
        methods: {
            ok(){

            },
            cancel(){

            },

            //刷新
            refresh(){
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {
                        id: this.maintainOrderAddMaintainDeviceRecordId
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.maintainOrdersDetail = res.data
                }).catch((err) => {
                    console.log(err)
                })
            },

            //弹出确认框
            showmodel(e){
                console.log(e)
                this.maintainOrderAddMaintainDeviceRecordModal=true
                this.maintainDeviceRecord.maintainOrderId = e.id
                // store.dispatch('MaintainOrderServ_GetCanMakeRecordDevices', {
                //     params: {id: e.id},
                //     urlparams: null
                // }).then(() => {
                //     let devices = store.getters.get_MaintainOrder_GetCanMakeRecordDevicesResult
                //     console.log(devices)
                //     if (devices) {
                //         this.devices = devices
                //     }
                // }).catch(err => {
                //     this.$Message.error(err)
                // })
            },
            //弹出删除框
            showdeletemodel(e){
                console.log(e)
                this.maintainOrderDeleteMaintainDeviceRecordModal= true,
                    this.maintainOrderDeleteMaintainDeviceRecordId= e.id
            },
            showmodel1(e){
                this.maintainOrderModifyMaintainDeviceRecordModal = true
                this.maintainOrderModifyMaintainDeviceRecordId = e.id
            },
            //指定业务员
            assignSalesman(e){
                this.changeBusinessUserModal = true
                // this.changeBusinessUserId  = e.id
            },
            //指派维修员
            onMaintainOrderChangeMaintainerModal(e){
                this.maintainOrderChangeMaintainerModal = true
                this.maintainOrderChangeMaintainerId = e.id
            },
            //重新预约
            onReschedule(e){
                console.log(e)
                this.rescheduleMaintainerModal = true
                this.rescheduleMaintainerId = e.id
            },
            //追加备注
            addremark(e) {
                this.remarkmodal = true
                this.remarkid = e.id
            },
            //确认添加备注
            ok1() {
                store.dispatch('MaintainOrderServ_AddToRemark', {
                    params: {
                        id: this.remarkid,
                        content: this.remarkvalue
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.remarkvalue = ''
                    this.refresh()
                }).catch((err) => {
                    console.log(err)
                    this.remarkvalue = ''
                })
            },
            //添加备注取消
            cancel1() {
                this.remarkvalue = ''
            },
            //上传图片页
            toUploadermaintainOrdersDetail(e){
                this.$router.push({
                    // name: 'maintainOrders-Uploaderimage',
                    name: 'maintainOrders-UploaderImage-vant',
                    query: {'maintainOrdersUploaderimage': e.id}
                })
            },
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'installermaintainorder'
                })
            },
            getCode() { // 非静默授权，第一次有弹框
                let code = this.$route.query.code
                if (!code) {
                    code = null
                }
                // window.location.href = 'https://devwxpa.jianchengjt.com/?code=' + code
                // 你自己的业务逻辑
                //微信公众服务号登录
                store.dispatch('AccountServ_LoginByWechatServiceAccount', {
                    params: {
                        wechatCode: code
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    console.log('登陆成功')
                    // this.$router.push({
                    //     name: 'orderDetails',
                    // })
                })
                    .catch((err) => {
                        console.log(err)
                        console.log('登陆失败')
                        // this.$router.push({
                        //     name: 'login',
                        // })
                    })
            },
        },
        mounted() {
            console.log(this.$route.query.maintainOrdersDetailid)
            let id
            if (this.$route.query.code != null) {
                this.getCode()
                id = this.$route.query.maintainOrdersDetailid
            } else {
                id = this.$route.query.maintainOrdersDetailid
            }
            this.maintainOrderAddMaintainDeviceRecordId = id
            this.maintainOrderModifyMaintainDeviceRecordId = id
            this.changeBusinessUserId = id
            this.maintainOrderChangeMaintainerId = id
            store.dispatch('MaintainOrderServ_GetDetail', {
                params: {
                    id: id
                },
                urlparams: null
            }).then((res) => {
                console.log(res)
                this.maintainOrdersDetail = res.data
            }).catch((err) => {
                console.log(err)
            })
        }
    }
</script>

<style scoped>

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }
</style>
